import React, { Component } from 'react';
import { func, number } from 'prop-types';
import './RoundingInput.scss';
import Dropdown from 'ps-components/Dropdown/Dropdown';

const DROPDOWN_VALUES = [
  '$1',
  '$5',
  '$10',
  '$50',
  '$100',
  '$500',
  '$1,000',
  '$5,000',
  '$10,000',
  '$50,000',
  '$100,000',
  '$500,000'
];
class RoundingInput extends Component {
  static propTypes = {
    onClick: func,
    value: number
  };

  render() {
    const { onClick, value } = this.props;

    return (
      <div className="range__rounding-section">
        <div className="range__rounding-label">Values rounded to</div>
        <Dropdown
          className="range__rounding-dropdown"
          dropdownClass="dropdown rounding__dropdown"
          dropdownItems={DROPDOWN_VALUES}
          itemOnClick={onClick}
          text={value}
        />
      </div>
    );
  }
}

export default RoundingInput;
